






import { mapActions, mapGetters } from 'vuex';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import { MStoreConstants } from '@/types';

export default {
  name: 'OidcCallback',
  computed: {
    ...mapGetters('oidcStore', ['oidcIsAuthenticated'])
  },
  methods: {
    ...mapActions('oidcStore', ['oidcSignInCallback']),
    getRedirectPath(this: any, redirectPath: any) {
      const fallbackRoute = localStorage.getItem(MStoreConstants.LocalStorageKeys.MStoreOidcRedirectRoute);

      localStorage.removeItem(MStoreConstants.LocalStorageKeys.MStoreOidcRedirectRoute);
      return fallbackRoute || redirectPath || '/';
    }
  },
  created(this: any) {
    if (this.oidcIsAuthenticated) {
      this.$router.go(1);
    } else {
      this.oidcSignInCallback()
        .then((redirectPath: any) => {
          this.$router.push(this.getRedirectPath(redirectPath));
        })
        .catch((err: any) => {
          this.$router.push('/oidc-callback-error');
        });
    }
  },
  components: {
    LoadingSpinner
  }
};
